import Vue from 'vue';
import Router from 'vue-router';
import MainNavbar from './components/layout/MainNavbar/MainNavbar.vue';
import axios from "axios";


import PersonalBlog from './views/PersonalBlog.vue';
import UploadAsn from './views/UploadAsn/UploadAsn.vue';
import UploadSycc from './views/UploadSycc/PricingAndAvailablity.vue';
import ImageSearch from './views/ImageSearch/ImageSearch.vue';
import SingleimageSearch from './views/SingleImageSearch/SingleImageSearch.vue';
import HandlingdaysUpload from './views/HandlingDaysUpload/HandlingDaysUpload.vue';
import ProductUpload from './views/ProductUpload/ProductUpload.vue';
import ProductUpdate from './views/ProductUpload/DeleteProductUpdate.vue';
import VtexProductUpload from './views/ProductUpload/VtexProductUpload.vue';
import GenericUpload from './views/GenericUpload/GenericUpload.vue';

import BulletpointsUpdate from './views/VtexUpdate/BulletPointsUpdate.vue';

import Multiplier from './views/Multiplier/Multiplier.vue';
import SKUGenerator from './views/SKUGenerator/SKUGenerator.vue';
import CategoryDashboard from './views/CategoryMaster/CategoryDashboard.vue';

import CategoryAdd from './views/CategoryMaster/CategoryAdd.vue';

import VtexJob from './views/Job/VtexJob.vue';
import VtexpricingJob from './views/Job/VtexPricingJob.vue';


import UploadJOB from './views/ProductUpload/VtexProductUploadJOB.vue';

import VtexpriceuploadJob from './views/ProductUpload/VtexPriceuploadJob.vue';



import GenericUploadNew from './views/GenericUpload/GenericUploadNew.vue';

import InventoryUpload from './views/InventoryUpload/InventoryUpload.vue';
import Return from './views/Return/Return.vue';
import BrandUpload from './views/BrandUpload/BrandUpload.vue';
import BrandCatagoryUpdate from './views/BrandUpload/BrandUpdate.vue';

import ReferencepriceUpload from './views/RefPricing/RefPricingUpload.vue';
import PricingQC from './views/PricingQC/PricingQC.vue';


import BrandAndCatagoryView from './views/BrandAndCatagoryView/BrandAndCatagoryView.vue';


// BrandUpload



import UserProfileLite from './views/UserProfileLite.vue';
import Profile from './views/Profile.vue';
import AddNewPost from './views/AddNewPost.vue';
import Errors from './views/Errors.vue';
import ComponentsOverview from './views/UserSetup.vue';
import Tables from './views/Tables.vue';
import BlogPosts from './views/BlogPosts.vue';
// import Registration from './views/Application/Registration.vue';



import PasswordReset from './views/Application/PasswordReset.vue';
import ForgotPassword from './views/Application/ForgotPassword.vue';
import Login from './views/Application/Login.vue';
import OTP from './views/Application/OTP.vue';
import home from './views/Application/home.vue';
import About from './views/Application/About.vue';
import ContactAs from './views/Application/ContactAs.vue';


//Custom changes


import CommodityAdd from './views/Commodity/CommodityAdd.vue';
import CommodityEdit from './views/Commodity/CommodityEdit.vue';
import UsersetupAdd from './views/Usersetup/UsersetupAdd.vue';
import Register from './views/Register/Register.vue';
import RegisterView from './views/Register/RegisterView.vue';


Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [

    {
      path: '/Dashboard',
      redirect: '/Dashboard',
      name: 'Home',
      component: MainNavbar,
      children: [{
          path: '/',
          redirect: '/Generic-Upload',
        },
        {
          path: '/blog-overview',
          name: 'blog-overview',
          component: PersonalBlog,
        },
        {
          path: '/user-profile-lite',
          name: 'user-profile-lite',
          component: UserProfileLite,
        },
        {
          path: '/add-new-post',
          name: 'add-new-post',
          component: AddNewPost,
        },
        {
          path: '/errors',
          name: 'errors',
          component: Errors,
        },
        {
          path: '/user-setup',
          name: 'user-setup',
          component: ComponentsOverview,
        },
        {
          path: '/Upload-Asn',
          name: 'Upload-Asn',
          component: UploadAsn,
        },
        {
          path: '/Upload-Sycc',
          name: 'Upload-Sycc',
          component: UploadSycc,
        },
        {
          path: '/Image-Search',
          name: 'Image-Search',
          component: ImageSearch,
        },
        {
          path: '/Singleimage-Search',
          name: 'Singleimage-Search',
          component: SingleimageSearch,
        },
        {
          path: '/Handlingdays-Upload',
          name: 'Handlingdays-Upload',
          component: HandlingdaysUpload,
        },
        
        {
          path: '/Vtex-Product-Upload',
          name: 'Vtex-Product-Upload',
          component: VtexProductUpload,
        },
        {
          path: '/Product-Upload',
          name: 'Product-Upload',
          component: ProductUpload,
        },
        {
          path: '/Product-Update',
          name: 'Product-Update',
          component: ProductUpdate,
        },
        {
          path: '/Brand-Upload',
          name: 'Brand-Upload',
          component: BrandUpload,
        },
        {
          path: '/Bulletpoints-Update',
          name: 'Bulletpoints-Update',
          component: BulletpointsUpdate,
        },

        
        {
          path: '/Pricing-QC',
          name: 'Pricing-QC',
          component: PricingQC,
        },

                
        {
          path: '/Category-Dashboard',
          name: 'Category-Dashboard',
          component: CategoryDashboard,
        },

        {
          path: '/Category-Add',
          name: 'Category-Add',
          component: CategoryAdd,
        },
        
        {
          path: '/Vtex-Job',
          name: 'Vtex-Job',
          component: VtexJob,
        },
        {
          path: '/Vtexpricing-Job',
          name: 'Vtexpricing-Job',
          component: VtexpricingJob,
        },

        {
          path: '/Vtexpriceupload-Job',
          name: 'Vtexpriceupload-Job',
          component: VtexpriceuploadJob,
        },
        

        {
          path: '/Upload-JOB',
          name: 'Upload-JOB',
          component: UploadJOB,
        },

        {
          path: '/Brand-Catagory-Update',
          name: 'Brand-Catagory-Update',
          component: BrandCatagoryUpdate,
        },
        // BrandUpdate

        {
          path: '/Brand-And-Catagory-View',
          name: 'Brand-And-Catagory-View',
          component: BrandAndCatagoryView,
        },
        {
          path: '/Referenceprice-Upload',
          name: 'Referenceprice-Upload',
          component: ReferencepriceUpload,
        },
        

        {
          path: '/Generic-Upload',
          name: 'Generic-Upload',
          component: GenericUpload,
        },

        {
          path: '/Generic-Upload-New',
          name: 'Generic-Upload-New',
          component: GenericUploadNew,
        },
        
        {
          path: '/SKU-Generator',
          name: 'SKU-Generator',
          component: SKUGenerator,
        },

        {
          path: '/Multiplier',
          name: 'Multiplier',
          component: Multiplier,
        },
        {
          path: '/Inventory-Upload',
          name: 'Inventory-Upload',
          component: InventoryUpload,
        },
        {
          path: '/Return',
          name: 'Return',
          component: Return,
        },
        // Return
        {
          path: '/tables',
          name: 'tables',
          component: Tables,
        },
        {
          path: '/blog-posts',
          name: 'blog-posts',
          component: BlogPosts,
        },
        {
          path: '/CommodityAdd',
          name: 'CommodityAdd',
          component: CommodityAdd,
        },
        {
          path: '/CommodityEdit',
          name: 'CommodityEdit',
          component: CommodityEdit,
        },
        {
          path: '/UsersetupAdd',
          name: 'UsersetupAdd',
          component: UsersetupAdd,
        },
         {
           path: '/Register',
           name: 'Register',
           component: Register,
         },
         {
          path: '/RegisterView',
          name: 'RegisterView',
          component: RegisterView,
        },
        {
          path: '/Profile',
          name: 'Profile',
          component: Profile,
        },

        {
          path: '*',
          redirect: '/errors',
        },
      ]
    },
    {
      path: '/',
      redirect: '/home',
      name: 'home',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        // {
        //   path: '/Registration',
        //   name: 'Registration',
        //   component: Registration,
        // },
        {
          path: '/home',
          name: 'home',
          component: home,
        },
        {
          path: '/Login',
          name: 'Login',
          component: Login,
        },
        {
          path: '/ForgotPassword',
          name: 'ForgotPassword',
          component: ForgotPassword,
        },
        {
          path: '/About',
          name: 'About',
          component: About,
        },
        {
          path: '/OTP',
          name: 'OTP',
          component: OTP,
        },
        {
          path: '/ContactAs',
          name: 'ContactAs',
          component: ContactAs,
        },
        {
          path: '/PasswordReset',
          name: 'PasswordReset',
          component: PasswordReset,
        },
      ]
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.fullPath == '/' || to.fullPath == '/login' || to.fullPath == '/Login' || to.fullPath == '/Registration' || to.fullPath == '/ForgotPassword' || to.fullPath == '/home' || to.fullPath == '/About' || to.fullPath == '/ContactAs'||to.fullPath == '/OTP') {
    console.log(from.fullPath);
    next()
  } else {
    var Token = sessionStorage.getItem("Token");
    if (Token != null && Token != undefined && Token != ""){
      if(from.fullPath =="/Upload-Sycc")
      {
      var Token = sessionStorage.getItem("Token");
      var data={
        Token :Token,
        CRUD :"clearSynccentricScrap",
        CreatedBy: sessionStorage.getItem("UserId")
      };
      var dataString = JSON.stringify(data);
      
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
      .then(function (response) {
        if (response.data.ErrorInfo == null) {
          console.log(response.data.Result);
        } else {

        }
      })
      .catch(function (response) {
        console.log(response);
         
      });
      }
      next();
    }
    else {
      next({
        name: 'Login'
      })
    }
  }

});
export default router;
